import React, { useEffect} from "react";
import { Table  } from 'antd';
import Card from "components/card";
import Button from "components/button";
import CrudOption from "components/dropdown/crudoption";
import { PlusOutlined } from '@ant-design/icons';
import { connect } from "react-redux";
import { getAccessRightList, doAccessRightDelete } from "../../../../redux/accessright/accessRightState";
import { getAccessRightLevelName, handleTableChange } from "../../../../utils/index";
import ColumnSearchFilter from 'components/search/ColumnSearchFilter';
import SearchFilter from "components/search/SearchFilter";

const AccessRightTable = ({ recordList, pagination, doSearch, filters, doDelete, ...props }) => {
  	const { getColumnSearchProps } = ColumnSearchFilter();
  	const columns = [
		{
	        title: `Role/Group`,
	        dataIndex: 'ari_access_group_name',
	        key: 'ari_access_group_name',
	        width: '18%',
			...getColumnSearchProps('ari_access_group_name'),
	        render:(ari_access_group_name) => <span>{ari_access_group_name}</span> 
	    },
	    {
	        title: `Module`,
	        dataIndex: 'ari_module_name',
	        key: 'ari_module_name',
	        width: '20%',
	        sorter: true,
	        ...getColumnSearchProps('ari_module_name'),
	        render:(ari_module_name) => <span>{ari_module_name}</span>
	    },
	    {
	        title: `Can View`,
	        dataIndex: 'acr_can_view',
	        key: 'acr_can_view',
	        width: '10%',
	        render:(acr_can_view) => <span>{getAccessRightLevelName(acr_can_view)}</span>  
	    },
		{
	        title: `Can Add`,
	        dataIndex: 'acr_can_add',
	        key: 'acr_can_add',
	        width: '10%',
	        render:(acr_can_add) => <span>{getAccessRightLevelName(acr_can_add)}</span>
	    },
	    {
	        title: `Can Edit`,
	        dataIndex: 'acr_can_edit',
	        key: 'acr_can_edit',
	        width: '10%',
	        render:(acr_can_edit) => <span>{getAccessRightLevelName(acr_can_edit)}</span>
	    },
		{
	        title: `Can Delete`,
	        dataIndex: 'acr_can_delete',
	        key: 'acr_can_delete',
	        width: '10%',
	        render:(acr_can_delete) => <span>{getAccessRightLevelName(acr_can_delete)}</span>
	    },
		{
	        title: `Can Export`,
	        dataIndex: 'acr_can_extract',
	        key: 'acr_can_extract',
	        width: '10%',
	        render:(acr_can_extract) => <span>{getAccessRightLevelName(acr_can_extract)}</span>
	    },
	    {
	        title: <Button extra="btn-small">
			      		<a href={`/console/access-rights/add`}>
					        <PlusOutlined />{' '}Add
					  	</a>
			    	</Button>,
	        dataIndex: 'acr_id',
	        key: 'acr_id',
	        width: '12%',
	        render:(acr_id) => <CrudOption baseRoute="/console/access-rights" recordId={acr_id} deleteHandler={doDelete}/>
	    },
    ];
    
	useEffect(() => {
	    doSearch({paginate: pagination.per_page});
    }, [doSearch, pagination.per_page]);

  	return (
	    <Card extra={"w-full h-full p-4"} {...props}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      		
	      		<SearchFilter placeholder="Search in Group or Module" searchHandler={doSearch} filters={filters} pagination={pagination}/>
	      		
	      		<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.acr_id}
		        	pagination={pagination}    
		            onChange={handleTableChange(doSearch, filters)}               	
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.accessRight.accessRightList?.items,
  	pagination: state.accessRight.accessRightList?.pagination,
	filters: state.accessRight.accessRightList?.filters,
  	requesting: state.accessRight.accessRightList?.requesting,
  	error: state.accessRight.accessRightList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getAccessRightList(filters)),
  	doDelete: (id) => dispatch(doAccessRightDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccessRightTable);